export const toolbar = {
	options: [
		'inline',
		'blockType',
		'fontSize',
		'fontFamily',
		'list',
		'textAlign',
		'colorPicker',
		'link',
		'embedded',
		'emoji',
		// 'image', disable image in favor of WP Media
		'remove',
		'history',
	],
};
